(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/start.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"grassroots\" class=\"\"></div>\n";
},"useData":true});
Handlebars.partials['svs-grassroots_shared-start'] = svs.grassroots_shared.templates.start;
})(svs, Handlebars);


 })(window);